import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { useLocation } from "react-router";
import { selectorStyles, categoriesInHeaderSelector } from "@/utils/constants";
import { Icon } from "../ServiceDrawer/Icon";

import { IAppointmentsDrawerAddServiceSelectorProps } from "@/shared/interfaces/Services";

export default function ServicesHeaderSelector({
    category,
    handleChangeCategory,
}: IAppointmentsDrawerAddServiceSelectorProps) {
    const location = useLocation();
    const isUserInServicePage = location.pathname.includes("services");

    return (
        <Box
            sx={
                isUserInServicePage
                    ? { width: "260px" }
                    : { minWidth: "100%", marginBottom: 2 }
            }
        >
            <FormControl fullWidth>
                <InputLabel
                    id='demo-simple-select-label'
                    sx={{
                        fontFamily: "'Nunito Sans', sans-serif !important",
                        color: "#47586E",
                    }}
                >
                    Категорії послуг
                </InputLabel>
                <Select
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                "& .MuiMenuItem-root": {
                                    height: 40,
                                    fontFamily:
                                        "'Nunito Sans', sans-serif !important",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    lineHeight: "20px",
                                    transition: "all 0.3s linear",
                                    display: "flex",
                                    justifyContent: "space-between",
                                },
                            },
                        },
                    }}
                    sx={{ ...selectorStyles, width: "100%" }}
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={category}
                    label='Категорії послуг'
                    onChange={handleChangeCategory}
                    renderValue={selected => {
                        if (selected === "all") {
                            return "Всі категорії";
                        }
                        return selected;
                    }}
                    IconComponent={Icon}
                >
                    {categoriesInHeaderSelector.map(item => (
                        <MenuItem value={item.name} key={item.id} id={item.id}>
                            {item.name}
                            {category === item.name ? (
                                <img
                                    src='/appointmenspage/check.svg'
                                    alt='check logo'
                                />
                            ) : null}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
